import { Injectable } from '@angular/core';
import { LogoutType } from '@core/const';
import { select, Store } from '@ngrx/store';
import { AuthService, StateUtils } from '@spartacus/core';
import { LoginForm } from '@user/const';
import { Observable } from 'rxjs';
import { CustomUserActions } from '../store/actions';
import { CustomUserSelectors } from '../store/selectors';
import { StateWithCustomUser } from '../store/user-state';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private logoutType?: LogoutType;

  constructor(
    private store: Store<StateWithCustomUser>,
    protected authService: AuthService,
  ) {}

  confirmPhone(phone: string, deliveryChannel?: string): void {
    this.store.dispatch(new CustomUserActions.RequestAuthCode(phone, deliveryChannel));
  }

  resetConfirmPhoneState(): void {
    this.store.dispatch(new CustomUserActions.RequestAuthCodeResetState());
  }

  getConfirmPhoneState(): Observable<StateUtils.LoaderState<LoginForm>> {
    return this.store.pipe(select(CustomUserSelectors.getLoginState));
  }

  getConfirmPhoneValue(): Observable<LoginForm> {
    return this.store.pipe(select(CustomUserSelectors.getLoginValue));
  }

  getConfirmPhoneLoading(): Observable<boolean> {
    return this.store.pipe(select(CustomUserSelectors.getLoginLoading));
  }

  getConfirmPhoneSuccess(): Observable<boolean> {
    return this.store.pipe(select(CustomUserSelectors.getLoginSuccess));
  }

  getConfirmPhoneError(): Observable<boolean> {
    return this.store.pipe(select(CustomUserSelectors.getLoginError));
  }

  getLogoutType(): LogoutType {
    return this.logoutType ?? 'current';
  }

  logout(logoutType?: LogoutType): void {
    this.authService.logout();
    this.logoutType = logoutType;
  }
}
